import { MapViewStore } from "./MapViewStore";

export class MapSlidePanel {

    private _lastSlidePanelAction: string = "";

    public constructor(
        private _mapStore: MapViewStore,
        private _showOpenPanelByDefault: boolean,
        private _rememberActivePanel: boolean,
    ) {
        this.addSlidingPanelsHandlers();
    }

    private addSlidingPanelsHandlers = (): void => {
        let self = this;
        let lastSlidePanelAction_forScope = self._lastSlidePanelAction;

        let onCloseSlidePanel = function () {
            let panel = $('#slide-panel');
            $('#slide-panel .content-panel').hide();

            panel.removeClass('visible').animate({
                'margin-left': '-315px'
            });

            setTimeout(function () {
                $('#slide-content').css("opacity", "0");
            }, 350);

            lastSlidePanelAction_forScope = null;
            self._mapStore.onActivePanelChanged("none");
        };

        let onSlidePanelClick = function () {
            let panel = $('#slide-panel');
            let action = $(this).data("action");
            let activeContentPanelId = "#slide-panel-" + action;

            if (self._rememberActivePanel === true) {
                self._mapStore.onActivePanelChanged(action);
            }

            //any action other than 'help'
            if (panel.hasClass("visible") && lastSlidePanelAction_forScope === action) {
                onCloseSlidePanel();
                $(this).blur();

            } else if (!panel.hasClass("visible")) {
                //main panel closed

                //close any tooltips open
                $("[data-bs-toggle='tooltip']").tooltip('hide');

                panel.addClass('visible').animate({
                    'margin-left': '0px'
                });
                $('#slide-content').css("opacity", "1");
            }

            if (panel.hasClass("visible")) {
                //hide all the content panels and show the correct one
                $('#slide-panel .content-panel').hide();
                $(activeContentPanelId).show();

                lastSlidePanelAction_forScope = action;

                //we need to initialise the legend maps when the panel is first shown
                //if (action === "overlays") {
                //    self.addOverlays();
                //}
            }

            return false;
        };

        $('.slide-panel-button').on('click', onSlidePanelClick);

        //handle close button on sliding panel
        $('#slide-panel .fa-times').on('click', () => {
            onCloseSlidePanel();
        });

        //set initial state for panel
        if (self._showOpenPanelByDefault) {
            let activePanel = self._mapStore.getMapInfo().activePanel;
            if (!activePanel && activePanel != "none") {
                //show the panel and default to layers
                $("#slide-panel-btn-overlays").click();
            } else if (activePanel != "none") {
                $(`#slide-panel-btn-${activePanel}`).click();
            }
        }
    }
}